<p-drawer [closeOnEscape]="false" [(visible)]="showProspect" [showCloseIcon]="false" position="right" [blockScroll]="true" [dismissible]="false" styleClass="w-12 lg:w-9 no-header p-0 prospect-form" [appendTo]="'body'"
(onHide)="closeSidebar()"
aria-label="prospect-form-sidebar"
data-testid="prospect-form-sidebar">

    <ng-template #header>
    <!-- Header -->
    <div class="border-bottom-1 border-300 flex align-items-center justify-content-between sticky left-0 top-0 w-full surface-0 z-5" data-testid="prospect-form-header">
        <div class="flex align-items-center">
            <div (click)="closeSidebar()" class="h-2rem w-2rem cursor-pointer surface-200 flex align-items-center justify-content-center"
                 aria-label="close-prospect-form"
                 data-testid="close-prospect-form">
                <i class="fa fa-times text-xl text-600"></i>
            </div>
            <h5 class="text-sm ml-3 mb-0">{{'Shared.CREATE-PROSPECT.HEADER_ADDPROSPECT' | translate}}</h5>
        </div>
    </div>
    </ng-template>


    <!--Header End-->
    <ng-template #content>
        <form [formGroup]="fg" (submit)="CreateProspectSubmit()" class="text-sm" data-testid="prospect-form">
            <p-toast key="client-toast" (onClose)="hideProspect.emit(clientId$.value || 0)" [style]="{marginTop: '80px'}" styleClass="custom-toast">
                <ng-template let-message pTemplate="message">
                    <div style="text-align: center;">
                        {{message.detail}}
                        <a href="javascript:void(0);" class="cursor-pointer text-primary" (click)="GoToClientDetails.emit({showClientSidebar: true, clientId: message.data.clientId})">
                            {{ message.data.clientName}}
                        </a>
                    </div>
                </ng-template>
            </p-toast>
    
            <div class="px-3 text-sm">
    
                 <!-- Tenant Details -->
                 <div class="pt-3" *ngIf="formType === 'contact'" data-testid="prospect-tenant-details-section">
                    <div class="surface-200 py-2 px-3 border-round font-bold text-sm">{{'Shared.CREATE-PROSPECT.TENANT_DETAILS' | translate}}</div>
                    <div class="pt-3">
                        <div class="grid md:px-3">
                            <div class="col-12">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase">
                                    {{'Shared.CREATE-PROSPECT.SELECT_TENANT' | translate}}
                                    <sup class="p-error">*</sup>
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <multi-tenant-list 
                                    (emittedTenant)="selectTenant($event)" [selectionMode]="'single'"[styleClass]="'w-full h-full border-none header__tenant-list'">
                                   </multi-tenant-list>
                                   <app-error-msg class="md:block p-error" *ngIf="TenantIdControl && TenantIdControl.touched && TenantIdControl.invalid" [errors]="TenantIdControl.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.SELECT_TENANT_ERROR' | translate"
                                   data-testid="prospect-tenant-error"> </app-error-msg>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
                        </div>
                    </div>
                </div>
    
                <!-- Personal Details -->
                <div class="pt-3" data-testid="prospect-personal-details-section">
                    <div class="surface-200 py-2 px-3 border-round font-bold text-sm">{{'Shared.CREATE-PROSPECT.PERSONAL_DETAILS' | translate}}</div>
                    <div class="pt-3">
    
                        <div class="grid md:px-3">
                            <div class="col-12 md:col-4">
    
                                <!-- When No Picture is Uploaded -->
                            <div *ngIf="!uploadSuccess" class="flex align-items-center">
                                <!-- <div (click)="uploadProfilePicture=true" class="flex align-items-center justify-content-center h-4rem w-4rem border-circle border-2 border-300 surface-200 cursor-pointer">
                                    <i class="fa fa-camera text-600 text-xl"></i>
                                </div> -->
                                <p-avatar (click)="uploadProfilePicture=true" icon="fa fa-camera text-600 text-xl" size='xlarge' shape="circle" styleClass="cursor-pointer"
                                aria-label="prospect-profile-picture"
                                data-testid="prospect-profile-picture"></p-avatar>
    
                                <div class="ml-3">
                                    <h3 class="text-sm mb-1 font-normal">{{'Shared.CREATE-PROSPECT.UPLOAD_PROFILE_PICTURE' | translate}}</h3>
                                    <p class="text-xs mb-0 text-600">{{ 'CreateEditStaff.ACCEPTED_FILE_TYPE' | translate }}: .Jpeg, .PNG, .JPG, .Gif</p>
                                </div>
                            </div>
                            <!-- When No Picture is Uploaded -->
    
                            <!-- Profile Picture After Upload -->
                            <div *ngIf="uploadSuccess" class="relative w-4rem text-center">
                                <p-avatar [image]="imageBase64 || existingImage" styleClass="w-4rem h-4rem" shape="circle"></p-avatar>
                                <div class="text-primary cursor-pointer fa fa-pencil-alt absolute right top-0 mt-2 -ml-2" (click)="uploadProfilePicture=true"></div>
                            </div>
                            <!-- Profile Picture After Upload -->
    
                            </div>
                            <div class="col-12 md:col-4">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase">
                                    {{'Shared.CREATE-PROSPECT.LABEL_FULLNAME' | translate}}
                                    <sup class="p-error">*</sup>
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <input type="text" pInputText class="w-full" formControlName="full_name" [autocomplete]="false" placeholder="{{'Shared.CREATE-PROSPECT.PLACEHOLDER_NAME' | translate}}" (ngModelChange)="capitalizeInput()"
                                    aria-label="prospect-full-name-input"
                                    data-testid="prospect-full-name-input"/>
                                    <app-error-msg class="md:block p-error" *ngIf="NameControl && NameControl.touched && NameControl.invalid" [errors]="NameControl.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.NAME' | translate"
                                    data-testid="prospect-full-name-error"> </app-error-msg>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                            <div class="col-12 md:col-4">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase">
                                    {{'Shared.CREATE-PROSPECT.LABEL_EMAILID' | translate}}
                                    <sup class="p-error" *ngIf="EmailIdControl && EmailIdControl.status === 'INVALID'">*</sup>
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <input type="email" pInputText class="w-full" formControlName="emailId" [autocomplete]="false" placeholder="name@example.com"
                                    aria-label="prospect-email-input"
                                    data-testid="prospect-email-input"/>
                                    <div class="p-error mt-2 text-xs" *ngIf="EmailIdControl && (EmailIdControl.errors && EmailIdControl.errors.emailExists) || emailAlreadyExists">
                                        <i class="fa fa-exclamation-circle mr-2"></i>
                                        <span>{{'Shared.CREATE-PROSPECT.EMAIL_EXISTS' | translate}}</span>
                                        <strong class="underline cursor-pointer" (click)="openClientSidebar(existClientForEmail?.clt_id)">{{existClientForEmail?.clt_full_name}}</strong>
                                    </div>
                                    <app-error-msg class="md:block p-error" *ngIf="EmailIdControl && EmailIdControl.touched && EmailIdControl.invalid" [errors]="EmailIdControl.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.EMAILID' | translate"
                                    data-testid="prospect-email-error"> </app-error-msg>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                            <div class="col-12 md:col-4">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase">
                                    {{'Shared.CREATE-PROSPECT.LABEL_MOBILENUMBER' | translate}}
                                    <sup class="p-error" *ngIf="MobileNoControl && MobileNoControl.status === 'INVALID'">*</sup>
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <ngx-intl-tel-input
                                        [cssClass]="MobileNoControl.invalid?'p-invalid':''"
                                        [enableAutoCountrySelect]="false"
                                        [enablePlaceholder]="true"
                                        [searchCountryFlag]="false"
                                        [selectFirstCountry]="false"
                                        [selectedCountryISO]="clientMobileNoCountry ? clientMobileNoCountry : tenantCountry"
                                        [onlyCountries]="onlyCountries"
                                        [maxLength]="15"
                                        [phoneValidation]="true"
                                        [separateDialCode]="true"
                                        formControlName="mobileNo"
                                        aria-label="prospect-mobile-input"
                                        data-testid="prospect-mobile-input">
                                    </ngx-intl-tel-input>
                                    <div class="p-error mt-2 text-xs" *ngIf="MobileNoControl && (MobileNoControl.errors && MobileNoControl.errors.mobileExists) || mobileAlreadyExists">
                                        <i class="fa fa-exclamation-circle mr-2"></i>
                                        <span>{{'Shared.CREATE-PROSPECT.MOBILE_EXISTS' | translate}}</span>
                                        <strong class="underline cursor-pointer" (click)="openClientSidebar(existClientForMobile?.clt_id)">{{existClientForMobile?.clt_full_name}}</strong>
                                    </div>
                                    <app-error-msg class="md:block p-error" *ngIf="MobileNoControl && MobileNoControl.touched && MobileNoControl.invalid" [errors]="MobileNoControl.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.MOBILENO' | translate"
                                    data-testid="prospect-mobile-error"> </app-error-msg>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                            <div class="col-12 md:col-8">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase">
                                    {{'Shared.CREATE-PROSPECT.LABEL_GENDER' | translate}}
                                    <sup class="p-error">*</sup>
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <!-- For Mobile Up -->
                                    <div class="hidden md:flex align-items-center">
                                        <div class="p-buttonset mr-2">
                                            <button
                                                type="button"
                                                *ngFor="let gEnum of MaleFemaleGender"
                                                pButton
                                                pRipple
                                                [label]="gEnum.value"
                                                [ngClass]="{'p-button-secondary md:border-1' : SelectedGender.value?.value !== gEnum.value }"
                                                (click)="SetGender(gEnum)"
                                                class="text-sm w-4-sm border-right-1 border-white"
                                                [attr.aria-label]="'select-prospect-gender-' + gEnum.value"
                                                [attr.data-testid]="'select-prospect-gender-' + gEnum.value">
                                            </button>
                                            <app-error-msg styleClass="md:block p-error" *ngIf="SelectedGender.touched && SelectedGender.invalid" [errors]="SelectedGender.errors" [fieldLabel]="'CreateEditStaff.GENDER' | translate"
                                            data-testid="prospect-gender-error"> </app-error-msg>
                                        </div>
    
                                        <p-select
                                            *ngIf="(showOtherGender | async)"
                                            [options]="OtherGender"
                                            (onChange)="SetGenderOnChange($event)"
                                            optionLabel="value"
                                            filterBy="name"
                                            styleClass="w-10rem md:w-15rem text-sm ml-3"
                                            placeholder="{{'Shared.CREATE-PROSPECT.PLACEHOLDER_OTHERGENDERS' | translate}}"
                                            aria-label="prospect-other-gender-dropdown"
                                            data-testid="prospect-other-gender-dropdown">
                                            <ng-template pTemplate="selectedItem">
                                                <div class="text-sm" *ngIf="SelectedGender && SelectedGender.value && !(SelectedGender.value.key === '1' || SelectedGender.value.key === '2')">
                                                    {{SelectedGender.value.value}}
                                                </div>
                                            </ng-template>
                                            <ng-template let-gender pTemplate="item">
                                                <div class="text-sm">{{gender.value}}</div>
                                            </ng-template>
                                        </p-select>
                                    </div>
                                    <!-- For Mobile Down -->
                                    <p-select
                                        [options]="(showOtherGender | async) ? EnumGender: MaleFemaleGender"
                                        formControlName="selectedGender"
                                        optionLabel="value"
                                        filterBy="name"
                                        styleClass="md:hidden text-sm w-full"
                                        placeholder="{{'CreateEditStaff.GENDER' | translate}}"
                                        aria-label="prospect-gender-dropdown-mobile"
                                        data-testid="prospect-gender-dropdown-mobile">
                                        <ng-template pTemplate="selectedItem">
                                            <div class="text-sm" *ngIf="SelectedGender && SelectedGender.value">{{SelectedGender.value.value}}</div>
                                        </ng-template>
                                        <ng-template let-gender pTemplate="item">
                                            <div class="text-sm">{{gender.value}}</div>
                                        </ng-template>
                                    </p-select>
                                    <app-error-msg styleClass="md:block p-error" *ngIf="SelectedGender.touched && SelectedGender.invalid" [errors]="SelectedGender.errors" [fieldLabel]="'CreateEditStaff.GENDER' | translate"
                                    data-testid="prospect-gender-error"> </app-error-msg>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Marketing Details -->
                <div class="pt-3">
                    <div class="surface-200 py-2 px-3 border-round font-bold text-sm">
                        {{'Shared.CREATE-PROSPECT.HEADER_MARKETING' | translate}}
                    </div>
                    <div class="pb-2 mb-1 pt-3">
                        <div class="grid justify-content-between px-3">
                            <div class="col-12 md:col-8 xl:col-6">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase">
                                    {{'EDIT_CLIENT_PROFILE.CHANNEL' | translate}}
                                    <sup class="p-error">*</sup>
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <div class="p-buttonset white-space-nowrap hidden md:flex">
                                        <button
                                            type="button"
                                            *ngFor="let channelOption of channelCollection"
                                            class="p-button-primary border-right-1 border-white text-sm"
                                            [ngClass]="{'p-button-primary': channelOption.channel === ChannelControl.value?.channel,'p-button-secondary': channelOption.channel !== ChannelControl.value?.channel}"
                                            (click)="ChannelControl.setValue(channelOption)"
                                            pButton
                                            pRipple
                                            [label]="channelOption.channel"
                                            [attr.aria-label]="'select-prospect-channel-' + channelOption.channel"
                                            [attr.data-testid]="'select-prospect-channel-' + channelOption.channel">
                                        </button>
                                    </div>
                                    <!-- For Mobile -->
                                    <p-select [options]="channelCollection" formControlName="channel" optionLabel="channel" placeholder="{{'EDIT_CLIENT_PROFILE.CHANNEL' | translate}}" styleClass="w-full text-sm md:hidden"
                                                aria-label="prospect-channel-dropdown-mobile"
                                                data-testid="prospect-channel-dropdown-mobile">
                                        <ng-template pTemplate="selectedItem">
                                            <div class="text-sm" *ngIf="ChannelControl && ChannelControl.value">
                                                {{ChannelControl.value.channel}}
                                            </div>
                                        </ng-template>
                                        <ng-template let-channel pTemplate="item">
                                            <div class="text-sm">{{channel.channel}}</div>
                                        </ng-template>
                                    </p-select>
                                    <app-error-msg class="md:block p-error" *ngIf="ChannelControl && ChannelControl.touched && ChannelControl.invalid" [errors]="ChannelControl.errors" [fieldLabel]="'EDIT_CLIENT_PROFILE.CHANNEL' | translate"
                                    data-testid="prospect-channel-error"> </app-error-msg>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                            <div class="col-12 md:col-4 xl:col-3">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase">
                                    {{'EDIT_CLIENT_PROFILE.ENQUIRY_SOURCE' | translate}}
                                    <sup class="p-error">*</sup>
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <p-select *ngIf="!showOtherSourceTextBox" [options]="Source" formControlName="source" placeholder="{{'EDIT_CLIENT_PROFILE.ENQUIRY_SOURCE' | translate}}" styleClass="w-full text-sm"
                                                aria-label="prospect-source-dropdown"
                                                data-testid="prospect-source-dropdown">
                                    </p-select>
                                    <input *ngIf="showOtherSourceTextBox" type="text" formControlName="source" pInputText class="w-full text-sm" placeholder="{{'EDIT_CLIENT_PROFILE.OTHER_SOURCE' | translate}}"
                                           aria-label="prospect-other-source-input"
                                           data-testid="prospect-other-source-input">
                                    <app-error-msg class="md:block p-error" *ngIf="SourceControl && SourceControl.touched && SourceControl.invalid" [errors]="SourceControl.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.ENQUIRYSOURCE' | translate"
                                    data-testid="prospect-source-error"> </app-error-msg>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                            <div class="col-12 xl:col-3">
                                <label class="font-medium text-700 text-xs mb-2 block white-space-nowrap uppercase">
                                    {{'EDIT_CLIENT_PROFILE.REFERED_BY' | translate}}
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <mini-search class="w-full text-sm" [disabledctrl]="clientData ? true : false" [showSelected]="true" [clientId]="referredBy" (clients)="GetClientReferrel($event)" (removedClient)="removeClient($event)"
                                                aria-label="prospect-referred-by-search"
                                                data-testid="prospect-referred-by-search">
                                    </mini-search>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                             <!-- Promotional Preference -->
                            <div class="col-12 xl:col-5">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase">
                                    {{'Shared.CREATE-PROSPECT.LABEL_PROMOTIONALPREFERENCE' | translate}}
                                </label>
                                <div class="grid text-sm">
                                    <div class="col-6 md:col-4 flex align-items-center" *ngFor="let preferenceOption of promotionalPreferenceCollection">
                                        <ng-container *ngIf="!showSkeleton">
                                            <div class="flex align-items-center mr-3">
                                                <i [class]="preferenceOption.icon + ' text-base mr-2'"></i>
                                                <span>{{preferenceOption.name}}</span>
                                            </div>
                                            <p-toggleSwitch [formControlName]="preferenceOption.name.toLowerCase()" (onChange)="PromotionalPreferenceToTrue(preferenceOption)"
                                                          [attr.aria-label]="'toggle-prospect-promotional-preference-' + preferenceOption.name.toLowerCase()"
                                                          [attr.data-testid]="'toggle-prospect-promotional-preference-' + preferenceOption.name.toLowerCase()">
                                            </p-toggleSwitch>
                                        </ng-container>
                                        <p-skeleton *ngIf="showSkeleton" width="100%" height="1.75rem"></p-skeleton>
                                    </div>
                                </div>
                                <app-error-msg class="md:block p-error"
                                    *ngIf="PromotionalPreferenceControl && PromotionalPreferenceControl.touched && PromotionalPreferenceControl.invalid"
                                    [errors]="PromotionalPreferenceControl.errors"
                                    [fieldLabel]="'Shared.CREATE-PROSPECT.LABEL_PROMOTIONALPREFERENCE' | translate"
                                >
                                </app-error-msg>
                            </div>
                            <!-- Promotional Preference -->
    
                             <!-- Sales Representative -->
                             <div class="col-12 md:col-6">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase">
                                    {{'Shared.CREATE-PROSPECT.SALES_REP' | translate}}
                                    <sup class="p-error">*</sup>
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <staff-selector [formGroup]="fg" [controlName]="NewRepresentative" [filterstaff]="staffIds$" [claims]="claims" [id]="selectedClientRep" [styleClass]="'w-full text-sm py-0 align-items-center'"
                                                    aria-label="prospect-sales-rep-selector"
                                                    data-testid="prospect-sales-rep-selector">
                                    </staff-selector>
                                    <app-error-msg class="md:block p-error" *ngIf="NewRepresentative && NewRepresentative.touched && NewRepresentative.invalid" [errors]="NewRepresentative.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.SALES_REP' | translate"
                                    data-testid="prospect-sales-rep-error">
                                    </app-error-msg>
                                </ng-container>
                                <span class="text-xs" *ngIf="NewRepresentative && NewRepresentative.disabled">
                                    {{'Shared.CREATE-PROSPECT.CLIENT_REP_CHANGE_INFO' | translate}}
                                </span>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
                             <!-- Sales Representative -->
    
                        </div>
                    </div>
                </div>
                <!-- Marketing Details -->
    
                <!-- Profile Linking -->
                <div>
                    <div class="surface-200 py-2 px-3 border-round font-bold text-sm">
                        {{'Shared.CREATE-PROSPECT.HEADER_PROFILE_LINKING' | translate}}
                    </div>
                    <div class="p-3">
                        <div class="grid align-items-center">
                            <div class="col-12 md:col-4 md:pr-3 flex align-items-center justify-content-between">
                                <div class="mr-5">{{'Shared.CREATE-PROSPECT.LABEL_LINK_TO_EXISTING' | translate}}</div>
                                <ng-container *ngIf="!showSkeleton">
                                    <p-toggleSwitch formControlName="is_child"
                                                  aria-label="toggle-prospect-profile-linking"
                                                  data-testid="toggle-prospect-profile-linking">
                                    </p-toggleSwitch>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="3rem" height="1.75rem"></p-skeleton>
                            </div>
                            <div *ngIf="fg.get('is_child')?.value" class="col-12 md:col-4">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase">
                                    {{'Shared.CREATE-PROSPECT.LABEL_SEARCH_PROFILE' | translate}}
                                    <sup class="p-error">*</sup>
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <mini-search class="w-full text-sm" [readonly]="false" [showSelected]="true" (clients)="getParentClientId($event)" (removedClient)="removeParentClient($event)"
                                                aria-label="prospect-parent-client-search"
                                                data-testid="prospect-parent-client-search">
                                    </mini-search>
                                    <app-error-msg class="md:block p-error" *ngIf="LinkedClientIdControl && LinkedClientIdControl.touched && LinkedClientIdControl.invalid" [errors]="LinkedClientIdControl.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.LINK_TO_EXISTING' | translate"
                                    data-testid="prospect-link-error">
                                    </app-error-msg>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
                            <div *ngIf="fg.get('is_child')?.value" class="col-12 md:col-4">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase">
                                    {{'Shared.CREATE-PROSPECT.LABEL_RELATIONSHIP' | translate}}
                                    <sup class="p-error">*</sup>
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <p-select [options]="relationships" formControlName="relation" [placeholder]="'ADMIN.COMMON.SELECT' | translate" optionLabel="name" styleClass="w-full"
                                                aria-label="prospect-relationship-dropdown"
                                                data-testid="prospect-relationship-dropdown">
                                        <ng-template pTemplate="selectedItem">
                                            <div class="text-sm" *ngIf="RelationshipControl && RelationshipControl.value">
                                                {{RelationshipControl.value.name}}
                                            </div>
                                        </ng-template>
                                        <ng-template let-relationship pTemplate="item">
                                            <div class="text-sm">{{relationship.name}}</div>
                                        </ng-template>
                                    </p-select>
                                    <app-error-msg class="md:block p-error" *ngIf="RelationshipControl && RelationshipControl.touched && RelationshipControl.invalid" [errors]="RelationshipControl.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.RELATIONSHIP' | translate"
                                    data-testid="prospect-relationship-error">
                                    </app-error-msg>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Profile Linking -->
    
                <!-- Additional Information -->
                <div>
                    <div [ngClass]="showAdditionalInformation ? '' :'mb-4'" (click)="showAdditionalInformation=!showAdditionalInformation" class="cursor-pointer surface-200 py-2 px-3 border-round font-bold text-sm flex align-items-center"
                         aria-label="toggle-additional-information"
                         data-testid="toggle-additional-information">
                        <span>{{'Shared.CREATE-PROSPECT.HEADER_ADDITIONAL_INFO' | translate}}</span>
                        <i class="fa text-primary ml-3" [ngClass]="showAdditionalInformation ? 'fa-chevron-circle-up' :'fa-chevron-circle-down'"></i>
                    </div>
                    <div *ngIf="showAdditionalInformation" class="p-3">
                        <div class="grid align-items-center">
    
                             <!-- Date of Birth -->
                             <div class="col-12 md:col-4">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-dob-label">
                                    {{'EDIT_CLIENT_PROFILE.DATE_OF_BIRTH' | translate}}
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <p-datepicker formControlName="dateOfBirth" [showIcon]="true" dateFormat="dd/mm/yy" [maxDate]="minDate" styleClass="w-full" placeholder="{{'EDIT_CLIENT_PROFILE.DATE_OF_BIRTH' | translate}}"
                                              aria-label="prospect-date-of-birth"
                                              data-testid="prospect-date-of-birth">
                                    </p-datepicker>
                                    <app-error-msg class="md:block p-error" *ngIf="DateOfBirthControl && DateOfBirthControl.touched && DateOfBirthControl.invalid" [errors]="DateOfBirthControl.errors" [fieldLabel]="'EDIT_CLIENT_PROFILE.DATE_OF_BIRTH' | translate"
                                                 data-testid="prospect-dob-error">
                                    </app-error-msg>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                            <!-- Emergency Contact Name -->
                            <div class="col-12 md:col-4">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-emergency-contact-label">
                                    {{'EDIT_CLIENT_PROFILE.EMERGENCY_CONTACT_NAME' | translate}}
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <input type="text" pInputText class="w-full" formControlName="emergencyContact" [placeholder]="'EDIT_CLIENT_PROFILE.EMERGENCY_CONTACT_NAME' | translate"
                                           aria-label="prospect-emergency-contact-input"
                                           data-testid="prospect-emergency-contact-input">
                                    <app-error-msg class="md:block p-error" *ngIf="EmergencyContactControl && EmergencyContactControl.touched && EmergencyContactControl.invalid" [errors]="EmergencyContactControl.errors" [fieldLabel]="'EDIT_CLIENT_PROFILE.EMERGENCY_CONTACT_NAME' | translate"
                                                 data-testid="prospect-emergency-contact-error">
                                    </app-error-msg>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                            <!-- Emergency Contact Number -->
                            <div class="col-12 md:col-4">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-emergency-number-label">
                                    {{'EDIT_CLIENT_PROFILE.EMERGENCY_CONTACT_NO' | translate}}
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <ngx-intl-tel-input
                                        [cssClass]="EmergencyNumberControl.invalid?'p-invalid':''"
                                        [enableAutoCountrySelect]="false"
                                        [enablePlaceholder]="true"
                                        [searchCountryFlag]="false"
                                        [selectFirstCountry]="false"
                                        [selectedCountryISO]="tenantCountry"
                                        [onlyCountries]="onlyCountries"
                                        [maxLength]="15"
                                        [phoneValidation]="true"
                                        [separateDialCode]="true"
                                        formControlName="emergencyNumber"
                                        aria-label="prospect-emergency-number-input"
                                        data-testid="prospect-emergency-number-input">
                                    </ngx-intl-tel-input>
                                    <app-error-msg class="md:block p-error" *ngIf="EmergencyNumberControl && EmergencyNumberControl.touched && EmergencyNumberControl.invalid" [errors]="EmergencyNumberControl.errors" [fieldLabel]="'EDIT_CLIENT_PROFILE.EMERGENCY_CONTACT_NO' | translate"
                                                 data-testid="prospect-emergency-number-error">
                                    </app-error-msg>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                            <!-- Second Mobile Number -->
                            <div class="col-12 md:col-4">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-second-mobile-label">
                                    {{'Shared.CREATE-PROSPECT.LABEL_SECOND_MOBILE' | translate}}
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <ngx-intl-tel-input
                                        [cssClass]="SecondMobileNoControl.invalid?'p-invalid':''"
                                        [enableAutoCountrySelect]="false"
                                        [enablePlaceholder]="true"
                                        [searchCountryFlag]="false"
                                        [selectFirstCountry]="false"
                                        [selectedCountryISO]="tenantCountry"
                                        [onlyCountries]="onlyCountries"
                                        [maxLength]="15"
                                        [phoneValidation]="true"
                                        [separateDialCode]="true"
                                        formControlName="secondMobileNo"
                                        aria-label="prospect-second-mobile-input"
                                        data-testid="prospect-second-mobile-input">
                                    </ngx-intl-tel-input>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                            <!-- Preferred Language -->
                            <div class="col-12 md:col-4">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-preferred-language-label">
                                    {{'Shared.CREATE-PROSPECT.LABEL_PREFERRED_LANGUAGE' | translate}}
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <p-select [options]="parseSupportedLang" optionLabel="LANG_ABBRE" styleClass="text-sm w-full" formControlName="preferredLanguage" [placeholder]="'common.PLACEHOLDER.SELECT' | translate"
                                              aria-label="prospect-preferred-language-dropdown"
                                              data-testid="prospect-preferred-language-dropdown">
                                        <ng-template pTemplate="selectedItem" *ngIf="PreferedLanguageFormControl && PreferedLanguageFormControl.value">
                                            <div class="text-sm">{{PreferedLanguageFormControl?.value?.LANG_ABBRE}}</div>
                                        </ng-template>
                                        <ng-template let-lang pTemplate="item">
                                            <div class="text-sm">{{lang.LANG_ABBRE}}</div>
                                        </ng-template>
                                    </p-select>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                            <!-- Organization -->
                            <div class="col-12 md:col-4" *ngIf="showClientOrganizationLink">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-organization-label">
                                    {{'Shared.CREATE-PROSPECT.ORGANIZATION' | translate}}
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <p-select [options]="organizations" formControlName="organisation" optionLabel="name" placeholder="{{'Shared.CREATE-PROSPECT.PLACEHOLDER_ORGANIZATION' | translate}}" filterBy="name" styleClass="w-full text-sm" [showClear]="true"
                                              aria-label="prospect-organization-dropdown"
                                              data-testid="prospect-organization-dropdown">
                                        <ng-template let-organization pTemplate="item">
                                            <div class="text-sm">{{organization.name}}</div>
                                        </ng-template>
                                    </p-select>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                            <!-- Pin Code -->
                            <div class="col-12 md:col-4">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-pincode-label">
                                    {{'Shared.CREATE-PROSPECT.LABEL_PINCODE' | translate}}
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <p-inputNumber formControlName="address_pin_code" class="w-full text-sm" styleClass="w-full text-sm" [maxlength]="10" [format]="false"
                                                 aria-label="prospect-pincode-input"
                                                 data-testid="prospect-pincode-input">
                                    </p-inputNumber>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                            <!-- Address -->
                            <div class="col-12 md:col-8">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-address-label">
                                    {{'Shared.CREATE-PROSPECT.LABEL_ADDRESS' | translate}}
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <input type="text" formControlName="address" pInputText class="w-full text-sm" placeholder="{{'Shared.CREATE-PROSPECT.LABEL_ADDRESS' | translate}}"
                                           aria-label="prospect-address-input"
                                           data-testid="prospect-address-input">
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                            <!-- National ID -->
                            <div class="col-12 md:col-4">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase" *ngIf="commonService.GetNationalidLocalization() | async as nationalid" data-testid="prospect-national-id-label">
                                    {{ nationalid.label | translate}}
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <input type="text" class="w-full text-sm" pInputText placeholder="" formControlName="national_id"
                                           aria-label="prospect-national-id-input"
                                           data-testid="prospect-national-id-input">
                                    <app-error-msg class="md:block p-error" *ngIf="NationalIdControl && NationalIdControl.touched && NationalIdControl.invalid && commonService.GetNationalidLocalization() | async as nationalid" [errors]="NationalIdControl.errors" [fieldLabel]=" nationalid.label | translate"
                                                 data-testid="prospect-national-id-error">
                                    </app-error-msg>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                            <!-- Tax Number -->
                            <div class="col-12 md:col-4">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-tax-number-label">
                                    {{'Shared.CREATE-PROSPECT.LABEL_TAX' | translate}}
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <input type="text" class="w-full text-sm" pInputText placeholder="" formControlName="taxNumber"
                                           aria-label="prospect-tax-number-input"
                                           data-testid="prospect-tax-number-input">
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                            <!-- Migration ID -->
                            <div class="col-12 md:col-4">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-migration-id-label">
                                    {{'Shared.CREATE-PROSPECT.LABEL_MIGRATION' | translate}}
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <input type="text" class="w-full text-sm" pInputText placeholder="" formControlName="migrationId"
                                           aria-label="prospect-migration-id-input"
                                           data-testid="prospect-migration-id-input">
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
    
                            <!-- Notes -->
                            <div class="col-12">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-notes-label">
                                    {{'Shared.CREATE-PROSPECT.LABEL_NOTES' | translate}}
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <textarea pTextarea formControlName="notes" class="w-full h-6rem" placeholder="{{'Shared.CREATE-PROSPECT.LABEL_NOTES' | translate}}"
                                             aria-label="prospect-notes-textarea"
                                             data-testid="prospect-notes-textarea">
                                    </textarea>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="6rem"></p-skeleton>
                            </div>
    
                            <!-- Medical Alert -->
                            <div class="col-12">
                                <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-medical-alert-label">
                                    {{'EDIT_CLIENT_PROFILE.MEDICAL_ALERT' | translate}}
                                </label>
                                <ng-container *ngIf="!showSkeleton">
                                    <textarea pTextarea formControlName="medicalAlert" class="w-full" placeholder="{{'EDIT_CLIENT_PROFILE.MEDICAL_ALERT' | translate}}"
                                             aria-label="prospect-medical-alert-textarea"
                                             data-testid="prospect-medical-alert-textarea">
                                    </textarea>
                                    <app-error-msg class="md:block p-error" *ngIf="MedicalAlertControl && MedicalAlertControl.touched && MedicalAlertControl.invalid" [errors]="MedicalAlertControl.errors" [fieldLabel]="'EDIT_CLIENT_PROFILE.MEDICAL_ALERT' | translate"
                                                 data-testid="prospect-medical-alert-error">
                                    </app-error-msg>
                                </ng-container>
                                <p-skeleton *ngIf="showSkeleton" width="100%" height="2.15rem"></p-skeleton>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Additional Information -->
    
                <!-- Create Opportunity Section -->
                <create-opportunity 
                    *ngIf="formType === 'prospect' && formEvent === 'create'" 
                    [parentForm]="fg" 
                    [tenantId]="selectedTenant"
                    aria-label="create-opportunity-section"
                    data-testid="create-opportunity-section">
                </create-opportunity>
                <!-- Walk-in Tour Section -->
                <walk-in-tour 
                    *ngIf="formType === 'walk-in-tour' && formEvent === 'create'" 
                    [parentForm]="fg" 
                    [staffList]="staffIds$ | async"
                    aria-label="walk-in-tour-section"
                    data-testid="walk-in-tour-section">
                </walk-in-tour>
                <!-- Walk-in Trial Section -->
                <walk-in-trial 
                    *ngIf="formType === 'walk-in-trial' && formEvent === 'create'" 
                    [parentForm]="fg" 
                    [staffList]="staffIds$ | async" 
                    [classList]="classList"
                    aria-label="walk-in-trial-section"
                    data-testid="walk-in-trial-section">
                </walk-in-trial>
            </div>
    
            <!-- Footer -->
            <div class="border-top-1 border-300 flex align-items-center justify-content-between sticky bottom-0 top-0 w-full surface-0 z-5 py-2 px-3" data-testid="prospect-form-footer">
                <p-button [label]="'EDIT_CLIENT_PROFILE.CANCEL' | translate" (onClick)="hideProspect.emit(clientId$.value || 0)" styleClass="text-sm p-button-link"
                         aria-label="cancel-prospect-form"
                         data-testid="cancel-prospect-form">
                </p-button>
                <p-button [label]="(clientData ? 'EDIT_CLIENT_PROFILE.SAVE_CHANGES' : 'Shared.CREATE-PROSPECT.BUTTON_CREATEPROFILE') | translate" type="submit" [loading]="isFormSubmitting" [disabled]="setBtnDisbale()" styleClass="text-sm"
                         aria-label="submit-prospect-form"
                         data-testid="submit-prospect-form">
                </p-button>
            </div>
    
        </form>

    </ng-template>
    
</p-drawer>

<!-- Upload Profile Picture Modal -->
<p-dialog [(visible)]="uploadProfilePicture" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '500px'}" styleClass="no-header-modal"
         aria-label="upload-profile-picture-dialog"
         data-testid="upload-profile-picture-dialog">
    <ng-template pTemplate="header" styleClass="hidden"></ng-template>
    <ng-template pTemplate="content" styleClass="p-0">
        <div class="p-3">
            <div class="relative border-2 border-dashed border-300 border-round p-5 text-center" data-testid="profile-picture-dropzone-container">
                <div class="flex flex-column align-items-center justify-content-center" data-testid="profile-picture-upload-content">
                    <i class="fa fa-upload text-600 text-4xl mr-3"></i>
                    <div>
                        <p class="text-sm md:text-base line-height-1 my-1" data-testid="profile-picture-upload-text">
                            {{ 'CreateEditStaff.DRAG_DROP' | translate }} <span class="text-primary">{{ 'CreateEditStaff.BROWSE' | translate }}</span>
                        </p>
                        <p class="text-xs md:text-sm mb-0 text-600" data-testid="profile-picture-file-types">{{ 'CreateEditStaff.ACCEPTED_FILE_TYPE' | translate }}: .Jpeg, .PNG, .JPG, .Gif</p>
                    </div>
                </div>
                <ngx-file-drop class="opacity-0 absolute w-full h-full top-0 left-0 z-1 cursor-pointer" dropZoneLabel="Drop files here" (onFileDrop)="handleFileSelect($event)" [accept]="'.png,.jpg,.jpeg,.gif'"
                             aria-label="profile-picture-dropzone"
                             data-testid="profile-picture-dropzone">
                    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                        <div (click)="openFileSelector()" class="w-full h-full absolute left-0 top-0"></div>
                    </ng-template>
                </ngx-file-drop>
            </div>
        </div>
        <!-- Footer -->
        <div class="p-3 flex justify-content-between align-items-center border-top-1 border-300">
            <button pButton pRipple type="button" label="Cancel" class="p-button-text text-sm" (click)="saveProfilePicture(false)"
                    aria-label="cancel-profile-picture-upload"
                    data-testid="cancel-profile-picture-upload">
            </button>
            <button pButton pRipple type="button" label="Save Profile Picture" class="text-sm" (click)="saveProfilePicture(true)"
                    aria-label="save-profile-picture-upload"
                    data-testid="save-profile-picture-upload">
            </button>
        </div>
        <!-- Footer -->
    </ng-template>
</p-dialog>

<app-lost-deal [showDailog]="showChooseReason" (closeMainDailog)="closeLostDeal($event)" [lostDealInfo]="lostDealItemInfo"
              aria-label="lost-deal-dialog"
              data-testid="lost-deal-dialog">
</app-lost-deal>

